/** localStorage: user has opened the app from home screen / standalone at least once (same origin). */
export const PWA_STANDALONE_USED_KEY = "gunclub_pwa_opened_standalone";
